
import { useEffect, useState, useContext } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import useToken from "../../hooks/useToken";
import { DataContext, DataProvier } from "./data/DataContext";
import { LineProgressBar, PagesTitle, ModalControl } from './components/controls';
import { InitPage, TotalPage } from './data/Data';
import { Pages, StepFinish } from './components/pages/';
import http from '../../services/http';
import { endPoints } from '../../utils/constanst';
import { BuildDataOportunity, propLoading, BuildDataNotification } from './data/Help'

import './IH_AutoExpedible_Contenido.css'

const IH_AutoExpedible_Contenido = () => {

    const { loading } = useToken();

    useEffect(() => {
        setTimeout(() => {
            const preloader: any = document.querySelector(".site-preloader");
            if (preloader) {
                preloader.addEventListener("transitionend", (event: any) => {
                    if (event.propertyName === "opacity") {
                        preloader.parentNode.removeChild(preloader);
                    }
                });
                preloader.classList.add("site-preloader__fade");
            }
        }, 600);
    }, []);

    return (
        <DataProvier loading={loading} >
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <Switch>
                    <Route exact path="/micrositio/cr/ih/autoexpedible_contenido/" component={Layout} />
                </Switch>
            </BrowserRouter>
        </DataProvier>
    );

}

const Layout = ({ location }: IPropsParam) => {
    const [index] = useState(InitPage);
    const [saved, setSaved] = useState(false);
    const { IH_CR } = useContext(DataContext);
    const [propModal, setPropModal] = useState(propLoading);


    const sendOportunity = () => {
        let searchParams = new URLSearchParams(location.search);
        let src = searchParams.get('source');
        const temp: IBuildData_IHCRAutoExpedibleContenido_Props = {
            src: src,
            data: IH_CR
        }

        const data = BuildDataOportunity(temp);
        setPropModal({ ...propLoading, active: true });
        http(endPoints.SendNotificationOpportunityDefault).post(data).then(() => {           
        }).catch(() => {

        }).finally(() => {

            setPropModal({ ...propLoading, active: false });
            setSaved(true);
        })
    }

    return (
        <div className="container">
            <div className="layout-ihcr-aec">
                {!saved && <>
                    <div className="mt-10">
                        <p className="lbl-encabezado1 mb-10">
                            ¡Calcula tu seguro ahora!
                        </p>
                        <p className="lbl-encabezado2 mt-0 mb-30">
                            Con tu póliza de Autoexpedible Contenido Seguro cuentás con el respaldo ante eventos inesperados
                        </p>
                    </div>
                    <LineProgressBar index={(index < TotalPage ? index + 1 : TotalPage)} totalPages={TotalPage} />
                    <form>
                        <div className="step-ihcr-aec">
                            <div className="step-container-ihcr">
                                <PagesTitle index={index} />
                                <Pages index={index} />
                            </div>
                        </div>
                        < div className="control-button-ihcr-aec mt-40 control-button-ihcr-only-aec">
                            <button
                                className="control-button-btn-ihcr-aec next"
                                type="button"
                                onClick={sendOportunity}
                            >
                                Siguiente
                            </button>
                        </div>
                    </form>
                </>
                }
                {saved && <StepFinish />}
                <ModalControl
                    active={propModal.active}
                    txtMsg={propModal.txtMsg}
                />
            </div>
        </div>
    );
}

export default IH_AutoExpedible_Contenido;